// src/pages/materials/MaterialsUserTemplateNew.jsx
import React, { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// 공용 에디터(사용자 템플릿)
import UserForm from "../../components/common/form/UserForm";

const FORM_TYPES = [
  { value: "PS", label: "수급계획" },
  { value: "PO", label: "발주서" },
  { value: "GR", label: "입고서" },
  { value: "GI", label: "출고서" },
  { value: "QC", label: "검수 요청" },
  { value: "CK", label: "검수 확인" },
];

export default function MaterialsUserTemplateNew() {
  const nav = useNavigate();
  const { id: projectId } = useParams();

  const [formType, setFormType] = useState("PS");

  const params = useMemo(
    () => ({
      module: "material",
      formType, // 반드시 대문자
      scope: "project",
      project: projectId,
    }),
    [formType, projectId]
  );

  return (
    <div className="p-4 space-y-4">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h2 className="text-xl font-semibold">사용자 템플릿 문서 작성</h2>
          <p className="mt-1 text-sm text-gray-500">
            프로젝트 공용 사용자 템플릿을 불러와 편집 후 저장합니다.
          </p>
        </div>
        <button
          className="rounded-lg border px-3 py-2 text-sm hover:bg-gray-50"
          onClick={() => nav(-1)}
        >
          뒤로
        </button>
      </div>

      {/* 문서 종류 선택 */}
      <div className="rounded-2xl border bg-white p-4">
        <div className="mb-2 text-sm text-gray-700">문서 종류</div>
        <select
          className="w-full max-w-xs rounded-xl border px-3 py-2 text-sm"
          value={formType}
          onChange={(e) => setFormType(e.target.value.toUpperCase())}
        >
          {FORM_TYPES.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>

      {/* 사용자 에디터 (매니저는 UserForm 내부에서만 렌더됩니다) */}
      <div className="rounded-2xl border bg-white p-3">
        <UserForm
          // formType 바뀔 때 내부 상태 초기화되도록 key 부여
          key={`${projectId}-${formType}`}
          mode={2}
          module="material"
          formType={formType}
          scope="project"
          project={projectId}
          defaultTitle="사용자 템플릿 문서"
        />
      </div>
    </div>
  );
}
